"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalUser = void 0;
class PortalUser {
    constructor(props) {
        this.complete = props.complete || false,
            this.country = props.country || null,
            this.email = props.email || null,
            this.fullname = props.fullname || null,
            this.phone = props.phone || null,
            this.timestamps = props.timestamps || {
                dt_create: null,
                dt_complete: null
            },
            this.timezone = props.timezone || null;
        this.nom035Coach = props?.nom035Coach || false;
    }
}
exports.PortalUser = PortalUser;
